namespace advisorop.domains {

    export enum RmdInheritedFlag {
        NON_INHERITED = 1,
        INHERITED
    }

    export enum RmdStatus {
        UNMET = 1,
        MET
    }

    export interface InvestorRmdStatusViewModel {
        id: number;
        advisoryFirmId: number;
        investorId: number;
        inheritedFlag: advisorop.domains.RmdInheritedFlag
        year: number;
        status: advisorop.domains.RmdStatus;
        notes: string;
    }

    export interface AccountRmdStatusViewModel {
        id: number;
        accountId: number;
        year: number;
        prevYearFMV: number;
        currYearRMD: number;
        ytdDistribution: number;
        remainingRMD: number;
        status: advisorop.domains.RmdStatus;
        notes: string;
    }

}